import {
  FaRegCalendarAlt,
  FaUserCircle,
  FaBriefcase,
  FaBuilding,
  FaStar,
} from 'react-icons/fa';

export const NOTIFICATION_DEFAULT_TARGET = '/dashboard?section=reservas';

export const isProposalNotification = item => {
  if (!item || item?.type !== 'request_proposal') return false;
  return Boolean(
    item?.data?.proposalId ||
      item?.data?.requestId ||
      item?.proposalId ||
      item?.requestId
  );
};

export const proposalNotificationHasClientContact = item => {
  if (!isProposalNotification(item)) return false;
  const contactName = item?.data?.clientContactName;
  const contactEmail = item?.data?.clientContactEmail;
  const contactPhone = item?.data?.clientContactPhone;
  return Boolean(
    (typeof contactName === 'string' && contactName.trim()) ||
      (typeof contactEmail === 'string' && contactEmail.trim()) ||
      (typeof contactPhone === 'string' && String(contactPhone).trim())
  );
};

export const resolveProposalNotificationUrl = item => {
  if (!item) return NOTIFICATION_DEFAULT_TARGET;
  if (item.destinationUrl) return item.destinationUrl;
  const requestId =
    item?.data?.requestId ||
    item?.requestId ||
    item?.data?.solicitudId ||
    item?.solicitudId;
  if (requestId) {
    return `/dashboard?section=solicitudes&requests=${encodeURIComponent(requestId)}`;
  }
  return NOTIFICATION_DEFAULT_TARGET;
};

export const resolveNotificationIcon = type => {
  switch (type) {
    case 'reservation':
    case 'reservation-created':
    case 'booking':
      return FaRegCalendarAlt;
    case 'profile_view':
    case 'user_profile_view':
    case 'profile':
    case 'user':
      return FaUserCircle;
    case 'publication_view':
      return FaBriefcase;
    case 'company':
    case 'enterprise':
      return FaBuilding;
    case 'review':
      return FaStar;
    default:
      return FaBriefcase;
  }
};

export const resolveNotificationTarget = item => {
  if (!item) return NOTIFICATION_DEFAULT_TARGET;
  if (isProposalNotification(item)) {
    return resolveProposalNotificationUrl(item);
  }
  if (item.destinationUrl) return item.destinationUrl;
  const suffix =
    item?.reservationId && item.reservationId !== ''
      ? `&reservation=${item.reservationId}`
      : '';
  return `${NOTIFICATION_DEFAULT_TARGET}${suffix}`;
};

export const formatNotificationDate = value => {
  if (!value) return '';
  const dateValue = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(dateValue.getTime())) return '';
  const now = new Date();
  const diffMs = now - dateValue;
  const diffMinutes = Math.floor(diffMs / 60000);
  if (diffMinutes < 1) return 'Justo ahora';
  if (diffMinutes < 60) return `Hace ${diffMinutes} min`;
  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) return `Hace ${diffHours} h`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays === 1) return 'Ayer';
  if (diffDays < 7) return `Hace ${diffDays} días`;
  return dateValue.toLocaleDateString('es-MX', {
    day: 'numeric',
    month: 'short',
  });
};
